module.exports = __webpack_public_path__ + "assets/appstore_bt.d0558d91.svg";